import React from 'react';
import { Input } from '../../../atoms/Input';
import useBSBValidation from '../../../hooks/data/useBSBValidation';

type Props = {
  value: string;
  error?: string;
  onChange: (tag: string, newValue: string) => void;
};

const BSBInput = (props: Props) => {
  const { value, error, onChange } = props;
  const { data: bsbInformation, error: bsbError } = useBSBValidation(value);

  const inputError = error ?? (bsbError ? 'Invalid BSB number' : undefined);
  return (
    <>
      <Input
        isFuturo
        tag="bsb"
        inputLabel="BSB"
        type="number"
        size="max"
        value={value}
        hasError={Boolean(inputError)}
        errorLabel={inputError}
        onChange={onChange}
      />
      {bsbInformation?.name && (
        <p className="text-body-small text-subtle">{bsbInformation.name}</p>
      )}
    </>
  );
};
export default BSBInput;
